import "react-toastify/dist/ReactToastify.css";
import useCgUploadDocument from "./useCgUploadDocument";
import DischargeSummary from "./DischargeSummary";
import SessionTable from "./SessionTableV2";
import { useState, useMemo } from "react";
import Button from "../../atoms/Button/Button";
import { NIVOLUMAB } from "../../data/nivoConsts";

interface CgUploadDocumentsProps {
  detailsObject: any;
  formData: any;
}
const initialSessions = [
  { visit_cycle: 1, follow_up_date: "", dosage: "", invoice: "", approved: false },
];

const CgUploadDocuments = ({ detailsObject, formData }: CgUploadDocumentsProps) => {
  const {
    coins,
    token,
    handleSave,
    doctorDetails,
    careGiverDetails,
  } = useCgUploadDocument();
  
  const { userDetails, patientData } = detailsObject;
  
  const [formObject, setFormObject] = useState({
    patient_id: patientData?.patient_id,
    patient_phone: patientData?.contact_no,
    patient_name: patientData?.name,
    updated_by: userDetails?.health_coach_id,
    support_program_drug: formData.type,
    dischargeSummary: null, // or "" if you want to store file name
    notes: "",
    therapy_indication: "",
    patientVisits: initialSessions,
    upcomingSession: {
      // follow_up_date: '',
      // dosage: '',
      is_drug_free: 1,
      // visit_cycle: 0,
      // notes: '',
    }
  });


  // Check if it's Nivolumab therapy
  const isNivo = useMemo(() => {
    return formData.type === NIVOLUMAB;
  }, [formData.type]);

  const updateFormObject = (key: string, value: any) => {
    console.log('key', key, 'value', value);
    setFormObject((prev: any) => ({
      ...prev,
      [key]: value
    }));
  };



  // console.log(patientDetails, "patientDetails");
  // console.log(careGiverDetails, "careGiverDetails");
  // console.log(doctorDetails, "doctorDetails");
  return (
    <>
      <div className="group-f-r-a-m-e">
        {/* Section 1 */}
        {/* <DischargeSummary
          formData={formData}
          formObject={formObject}
          updateFormObject={updateFormObject}
        /> */}
        {/* Section 2 */}
        <SessionTable
          detailsObject={detailsObject}
          formData={formData}
          formObject={formObject}
          setFormObject={setFormObject}
          cycleCompleted={formData.cycles_completed || 0}
          isNivo={isNivo}
          updateFormObject={updateFormObject}
        />

      {/* <div className="mt-4 flex justify-center">
        <Button onClick={handleSubmit}>
          Submit
        </Button>
      </div> */}
      {/* <pre>{JSON.stringify(formObject, null, 2)}</pre> */}
      </div>
    </>
  );
};

export default CgUploadDocuments;
